import React from 'react';

import { RequestsTableInner } from './components';
import { REQUESTS_COLUMNS_CONSUMER } from './constants';

export const RequestsTableConsumer: React.FC = () => {
  return <RequestsTableInner columns={REQUESTS_COLUMNS_CONSUMER} />;
};
